import { render, staticRenderFns } from "./PermissionSearch.vue?vue&type=template&id=c04feb52&scoped=true&"
import script from "./PermissionSearch.vue?vue&type=script&lang=js&"
export * from "./PermissionSearch.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSearch.vue?vue&type=style&index=0&id=c04feb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04feb52",
  null
  
)

export default component.exports